import { Clinic } from '../../../ana-toolbox'

export const HAUPTWACHE = '62448424-b75a-4499-9c65-35f2e044ae15'

export const STAGING_REGENSBURG = '03afa28e-5ead-4312-ab3a-abb1257fe8b2'

const CLINICS_ALLOWING_ALL_PHONE_TYPES = [HAUPTWACHE, STAGING_REGENSBURG]

export const shouldAllowAllPhoneTypes = (clinic: Pick<Clinic, 'referenceId'>) => {
  return CLINICS_ALLOWING_ALL_PHONE_TYPES.includes(clinic.referenceId)
}
